module.exports = __webpack_public_path__ + "img/advantage4.22fddf95.svg";